import { api } from "api/apiHelper";
import { Endpoints } from "api/apiConst";

export const updateMe = (data: {}) => {
  return api.patch(Endpoints.USERS_ME, data).then((response) => response.data);
};
